import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('no'); // 'no' for Norwegian, 'en' for English

  const toggleLanguage = () => {
    setLanguage(language === 'no' ? 'en' : 'no');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100">
      <Header language={language} onToggleLanguage={toggleLanguage} />
      <Hero language={language} />
      <Features language={language} />
      <HowItWorks language={language} />
      <Benefits language={language} />
      <CTA language={language} />
      <Footer language={language} />
    </div>
  );
}

export default App;

